const state= {
    isShowLoginDialog: false,
    cartNum: 0, //购物车数量
    userInfo:{},
    userId: 0,
    defaultCity:"上海",
    keyWord:"",
    isCartPopTipShow: false, // 加入购物车弹层提示
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js